import React, { memo } from "react";
import { useSelector } from "react-redux";

export const FilterIcon = memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M1.75 4.08342C1.75 2.95583 2.66408 2.04175 3.79167 2.04175C4.91925 2.04175 5.83333 2.95583 5.83333 4.08342C5.83333 5.211 4.91925 6.12508 3.79167 6.12508C2.66408 6.12508 1.75 5.211 1.75 4.08342ZM11.6667 4.66675H7V3.50008H11.6667V4.66675ZM8.16667 9.91675C8.16667 8.78917 9.08075 7.87508 10.2083 7.87508C11.3359 7.87508 12.25 8.78917 12.25 9.91675C12.25 11.0443 11.3359 11.9584 10.2083 11.9584C9.08075 11.9584 8.16667 11.0443 8.16667 9.91675ZM7 9.33342V10.5001H2.33333V9.33342H7Z"
      fill="#2B3674"
    />
  </svg>
));

export const NoDataMessage = memo(({ message, style = {} }) => {
  const organisationsList = useSelector((state) => state?.organisationSlice?.organisationsList);
  const hasNoMembers = Array.isArray(organisationsList) && organisationsList.length === 0;

  return (
    <div
      className="w-100 d-flex justify-content-center align-items-center"
      style={{
        flex: 1,
        minHeight: "317px",
        color: "#A3AED0",
        fontSize: "14px",
        ...style,
      }}
    >
      <p
        className="m-0"
        style={{
          maxWidth: "450px",
          textAlign: "center",
          width: "100%",
          paddingTop: style.paddingTop || "0px",
        }}
      >
        {message || (
          hasNoMembers
            ? "Data will display here when Member Organisations have joined your Organisation Group."
            : "We couldn’t find any activity for your chosen date range. Try adjusting your filters and check again."
        )}
      </p>
    </div>
  );
});

export const ComingSoonMessage = memo(({ message = "Coming soon" }) => (
  <div
    className="w-100 d-flex justify-content-center align-items-center"
    style={{
      height: "317px",
      color: "#A3AED0",
      fontSize: "18px",
      fontWeight: "600",
    }}
  >
    <p
      className="m-0"
      style={{
        maxWidth: "450px",
        textAlign: "center",
        width: "100%",
      }}
    >
      {message}
    </p>
  </div>
));

export const LoadingMessage = memo(({ message = "Loading dashboard data...", style = {} }) => (
  <div
    className="w-100 d-flex justify-content-center align-items-center"
    style={{
      height: "317px",
      color: "#A3AED0",
      fontSize: "14px",
      ...style,
    }}
  >
    <p
      className="m-0"
      style={{
        maxWidth: "450px",
        textAlign: "center",
        width: "100%",
        paddingTop: "40px",
      }}
    >
      {message}
    </p>
  </div>
));
